import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) { config.headers = config.headers || {}; config.headers.Authorization = `Bearer ${token}`; }
  return config;
});

export async function getCoverage() {
  const { data } = await client.get('/prensa/coverage');
  return data;
}
export async function listContacts() {
  const { data } = await client.get('/prensa/contacts');
  return data.contacts || [];
}
export async function createContact(payload) {
  const { data } = await client.post('/prensa/contacts', payload);
  return data.contact;
}
export async function updateContact(payload) {
  const { data } = await client.patch('/prensa/contacts', payload);
  return data.contact;
}
export async function deleteContact(id) {
  await client.delete('/prensa/contacts', { data: { id } });
}
export async function generarGacetilla(payload) {
  const { data } = await client.post('/prensa/gacetilla', payload);
  return data;
}
